import { DatePicker, DatePickerProps } from 'antd';
import locale from 'antd/es/date-picker/locale/en_US';

const EiqDatePicker = (props: DatePickerProps) => {
  return (
    <DatePicker
      locale={{
        ...locale,
        lang: {
          ...locale.lang,
          shortMonths: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ],
        },
      }}
      {...props}
    />
  );
};

export default EiqDatePicker;
